import { Button } from "risa-oasis-ui_v2";

interface ModalFooterProps {
  onClose: () => void;
  onSave: () => void;
  isSaving?: boolean;
}

const ModalFooter = ({ onClose, onSave, isSaving }: ModalFooterProps) => {
  return (
    <div className="edit-dx-code-panel__footer mt-auto flex justify-center gap-3 border-t border-[#e5e7eb] bg-white px-6 py-4">
      <Button
        buttonType="secondary"
        size="medium"
        onClick={onClose}
        disabled={isSaving ?? false}
      >
        Cancel
      </Button>
      <Button
        buttonType="primary"
        size="medium"
        onClick={onSave}
        disabled={isSaving ?? false}
      >
        {isSaving ? "Saving..." : "Save"}
      </Button>
    </div>
  );
};

export default ModalFooter;
